module.exports = __webpack_public_path__ + "static/media/card2_6.ff30f577.png";